// extracted by mini-css-extract-plugin
module.exports = {"CallingPopupWraper":"CallingPopup_CallingPopupWraper__bHaPy","lottie":"CallingPopup_lottie__bFe_b"};